export type StatusBadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

interface StatusBadgeProps {
  label: string;
  tone?: StatusBadgeTone;
  size?: 'sm' | 'md';
  className?: string;
  title?: string;
}

export function StatusBadge({
  label,
  tone = 'neutral',
  size = 'md',
  className = '',
  title,
}: StatusBadgeProps) {
  return (
    <span
      className={`status-badge status-badge--${tone} status-badge--${size} ${className}`.trim()}
      title={title ?? label}
    >
      <span className="status-badge__label">{label}</span>
    </span>
  );
}

export default StatusBadge;
